const Data = [
  {
    name: "Vivekadithya Yayavaram",
    position: "Sponsorship Head",
    imageUrl: "/assets/images/members/Heads25/VivekadithyaYayavaram.jpg",
    facebookLink: "https://www.facebook.com/profile.php?id=61551520094855",
    linkedinLink: "https://www.linkedin.com/in/vivekadithya-yayavaram-8002a2291/",
    email: "y.vivekadithya@gyws.org"
  },
  {
    name: "Mahaveer Solanki",
    position: "Sponsorship Head",
    imageUrl: "/assets/images/members/Heads25/MahaveerSolanki.jpg",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  },
  {
    name: "Sai Surendra Rongali",
    position: "Sponsorship Head",
    imageUrl: "/images/profile.png",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  }
];

export default Data;